import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { EmailCreateGet, EmailCreateParams } from '@app/services/email-create.service';

@Component({
    selector: 'tt-email-create-view',
    templateUrl: './email-create-view.component.html',
    styleUrls: ['./email-create-view.component.css'],
})
export class EmailCreateViewComponent {
    public params;

    public heading = '';

    public get?: EmailCreateGet;

    constructor(private state: StateService) {
        console.log(state.getStateParams());
        this.params = state.getStateParams() as unknown as EmailCreateParams;
    }

    public setHeading(get: EmailCreateGet) {
        this.heading = get.emailcreate_heading;
        this.get = get;
    }

    public onSubmit() {
        if (window.location.href.includes('ispopup')) {
            window.close();
            return;
        }

        if (this.get?.after_create_email_goto_orderheads === '1') {
            if (this.params.argtype === 'order_internal_no') {
                this.state.back('/orderheads/-/-');
            } else if (this.params.argtype === 'invoice_no') {
                this.state.back('/invoiceheads/-/-');
            } else {
                this.state.back();
            }
        } else {
            this.state.back();
        }
    }
}
